module.exports = __webpack_public_path__ + "img/constellations.70ff22ae.jpg";